import { connect } from 'react-redux'
import PlayInList, { PlayInListProps } from './PlayInList'
import { State } from '../../dataStore/reducers/reducerType'
import { fetchChannelCommunications } from '../../dataStore/slices/communications/communicationsSlice'

type DispatchProps = 'fetchChannelCommunications'

const mapStateToProps = (state: State, props: Pick<PlayInListProps, 'dataBdd' | 'listHeight' | 'emptyRenderer'>): Omit<PlayInListProps, DispatchProps> => {

  return {
    list: state.communications.communications,
    total: state.communications.total,
    showAddButton: true,
    addedPlayIns: state.playIn.playInDetails,
    scrollToIndex: 0,
    dataBdd: props.dataBdd,
    listHeight: props.listHeight,
    emptyRenderer: props.emptyRenderer
  }

}

const mapDispatchToProps = (dispatch): Pick<PlayInListProps, DispatchProps> => ({
  fetchChannelCommunications: (startIndex, eraseOld, promiseResolver) =>
    dispatch(fetchChannelCommunications({ startIndex, eraseOld, promiseResolver }))
})

export default connect(mapStateToProps, mapDispatchToProps)(PlayInList)
